import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  customizeEnabled: attr(Boolean),
  enabledFulfillmentMethodIds: repeated(String),
  promptEnabled: attr(Boolean, {
    defaultValue: false
  }),
  promptTiming: attr(String, {
    defaultValue: ''
  })
}).reopenClass({
  /**
   * Override deserialize to always return a valid settings object.
   * This ensures the setting row appears in the UI even when the backend
   * doesn't return fulfillment_method_overrides data.
   */
  deserialize(data) {
    // Always return a valid object to ensure the setting appears in the UI
    return this.create({
      _data: data ?? {}
    });
  }
});